import React, { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router';
import LoadingSpinner from '../../common/src/components/LoadingSpinner';
import usePartyId from '../../common/src/hooks/query-params/usePartyId';
import useSessionId from '../../flows/src/hooks/useSessionId';
import useCompanyScanResetState from '../hooks/useCompanyScanResetState';
import useAuth from '../../app/src/features/authentication/hooks/useAuth';
import { getConversationById } from '../../conversations/src/features/detail/shared/api/getConversationById';
import {
  isConversationUrl,
  isSocialLoginUrl,
} from '../../app/src/features/authentication/constants/SocialAuth';
import { ConversationStatus } from '../../conversations/src/features/overview/types/OverviewTypes';
import useCaptchaV3 from '../../app/src/features/authentication/hooks/useCaptchaV3';

const CompanyScan: React.FC<React.PropsWithChildren<unknown>> = () => {
  const { distribution } = useAuth();

  // Routing
  const { search } = useLocation();
  const history = useHistory();
  const sessionId = useSessionId();

  // Redux
  const partyId = usePartyId();
  const { reset } = useCompanyScanResetState();

  const pushUser = () => {
    if (sessionId || partyId) {
      history.replace({ pathname: '/company-scan/intro', search });
    } else {
      history.replace({ pathname: '/company-scan/lookup', search });
    }
  };

  const proxy = async () => {
    if (isConversationUrl && sessionId) {
      try {
        const data = await getConversationById(sessionId);
        if (data.status === ConversationStatus.COMPLETED) {
          history.replace({
            pathname: '/company-scan/already-completed',
            search,
          });
        } else {
          pushUser();
        }
      } catch (_) {
        pushUser();
      }
    } else {
      pushUser();
    }
  };

  // Hooks
  const { executeCaptcha, isCaptchaAvailable } = useCaptchaV3(proxy);

  useEffect(() => {
    reset();
    if (isSocialLoginUrl) {
      if (isCaptchaAvailable) executeCaptcha(distribution.email);
    } else {
      proxy();
    }
  }, [isCaptchaAvailable]);

  return (
    <>
      <LoadingSpinner />
    </>
  );
};

export default CompanyScan;
